import { takeLatest, call, put} from 'redux-saga/effects';
import { LOGIN_VERIFY, LOGIN_ERROR, LOGIN_REVALIDATE } from '../types';
import { checkSession } from '../../services/authServices';

export function* verifyToken({ payload }) {
  try {
    const response = yield call(checkSession);
    if (response.status === 200) {
      yield put({ type: LOGIN_REVALIDATE, payload: response.data });
    } else {
      yield put({ type: LOGIN_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: LOGIN_ERROR, payload: error?.response?.data?.message });
  }
}

export default function* checkToken() {
  yield takeLatest(LOGIN_VERIFY, verifyToken);
}
